import { render, staticRenderFns } from "./ConfigurazionePazientiMenuList.vue?vue&type=template&id=2ba5883a"
import script from "./ConfigurazionePazientiMenuList.vue?vue&type=script&lang=js"
export * from "./ConfigurazionePazientiMenuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports